module.exports = "/_next/static/images/bm-7d91827f0f3930f645a0135ffe9eeb30.svg";